export enum AppResponseStatus {

  STATUS_SUCCESS = 200,
  STATUS_CREATED = 201,
  STATUS_UNAUTHORIZED = 401,
}
